<template>
  <div style="background: #4953cf;">
    <div class="header-content">
      <div>
        <span>我的寝室</span>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <span class="dorm-text">{{currentUser.room? currentUser.loudong + currentUser.room : "请绑定寝室再进行充值"}}</span>
      </div>
      <div class="dorm-mesage">{{currentUser.name}}</div>
    </div>
    <div class="fee-content" v-if="!rebindFlag">
      <div class="fee-content-1">
        <div class="dorm-mesage" style="font-weight:600">如遇更换寝室，可重新绑定新的寝室</div>
      </div>
      <div style="text-align: center;border: 1px solid white;margin-top: 80px;">
        <button class="recharge-btn" @click="rebinding">重新绑定</button>
      </div>
    </div>
    <div class="fee-content" v-if="rebindFlag">
      <div class="fee-content-1">
        <div style="font-weight:600">绑定寝室</div>
      </div>
      <div class="weui-cells weui-cells_form">
        <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label">姓名</label></div>
            <div class="weui-cell__bd">
                <input class="weui-input" placeholder="请输入姓名" v-model="userName">
            </div>
        </div>
        <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label">楼栋寝室</label></div>
            <div class="weui-cell__bd" @click="chooiceBuilding">
                <input class="weui-input" placeholder="请选择寝室" v-model="roomFullName" disabled>
            </div>
        </div>
        <div class="weui-cell">
          <button style="width: 100%;height: 40px;font-weight: 500;font-size: 18px;" @click="chooiceBuilding">选择寝室</button>
        </div>
      </div>
      <div style="text-align: center;border: 1px solid white;margin-top: 40px;">
        <button class="recharge-btn" @click="saveBinding">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import weui from 'weui.js';
export default {
  name: 'container',
  data() {
    return {
      rebindFlag: false,
      dormName: null,
      userName: null,
      buildingName: null,
      roomId: null,
      roomFullName: null
    }
  },
  computed: mapState({
    currentUser: state => state.user.currentUser,
    roomTree: state => state.room.roomTree
  }),
  async created() {
    this.rebindFlag = (!this.currentUser.name || !this.currentUser.room)
    await this.$store.dispatch({type: 'room/getRoomList'})
  },
  methods: {
    chooiceBuilding() {
      weui.picker(this.roomTree, {
        className: 'fm-picker',
        container: 'body',
        onConfirm: (result) => {
          this.buildingName = result[0].name.trim()
          this.dormName = result[1].name.trim()
          this.roomFullName = `${result[0].name.trim()}${result[1].name.trim()}`
          this.roomId = result[1].id
        },
        id: 'singleLinePicker'
      })
    },
    rebinding() {
      this.rebindFlag = true;
    },
    async saveBinding() {
      if(!this.userName || !this.dormName){
        weui.alert("请填写姓名和寝室", {
          className: "fm-border"
        })
        return
      }
      await this.$store.dispatch({type: 'user/saveRoom', data:{
        name: this.userName,
        roomId: this.roomId
      }})
      this.rebindFlag = false;
      this.userName = null;
      this.dormName = null;
      this.roomId = null;
      this.$router.replace({path: '/recharge'})
    }
  }
}
</script>

<style scoped>
  .header-content{
    background: #4953cf;
    min-height: 130px;
    color: white;
    padding: 30px;
  }
  .header-content span{
    font-weight: 600;
  }
  .dorm-text{
    font-size: 30px;
  }
  .dorm-mesage{
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
    font-weight:600;
  }
  .project{
    margin-top: 30px;
    background: white;
    color: #000;
    border-radius: 20px;
    text-align: center;
  }
  .project-main-text{
    color: #4b52aa;
    font-size: 18px;
    font-weight: 500;
    height: 70px;
    line-height: 70px;
  }
  .fee-content{
    border-radius: 20px 20px 0px 0px;
    background: white;
  }
  .fee-content-1{
    padding: 40px 20px 20px 20px;
  }
  .recharge-btn{
    height: 40px;
    width: 290px;
    background: #363fa3;
    color: white;
    font-weight: 500;
    border-radius: 20px;
    font-size: 18px;
  }
</style>